import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { felixTokens } from "../../../../theme";

type Props = {
  nome: string;
  descricao: string;
  logo: JSX.Element;
  ctaLabel: string;
  ctaHref: string;
  background: string;
  textColor?: string;
};

export default function CardParceiro({
  nome,
  descricao,
  logo,
  ctaLabel,
  ctaHref,
  background,
  // Tinta clara da marca (papel quente), não branco puro.
  textColor = "text.primaryWhite",
}: Props) {
  return (
    <Card
      sx={{
        height: "100%",
        background: background,
        color: textColor,
        display: "flex",
        flexDirection: "column",
      }}
      elevation={0}
    >
      <CardContent
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          flexGrow: 1,
          "&:last-child": {
            pb: 2,
          },
        }}
      >
        <Box display="flex" alignItems="center" height={40}>
          {logo}
        </Box>

        <Typography variant="h4" sx={{ color: textColor }}>
          {nome}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: textColor,
            opacity: 0.9,
            flexGrow: 1,
          }}
        >
          {descricao}
        </Typography>

        {/* A placa do card não acompanha o tema — é sempre escura (ver
            conta/parceiros). O CTA precisa acompanhar a placa, não o tema:
            em `secondary` o botão vira quase-preto no light (1,03:1 contra a
            placa, some por completo) e creme no dark. Fixamos a tinta clara. */}
        <Button
          variant="contained"
          href={ctaHref}
          target="_blank"
          fullWidth
          sx={{
            mt: "auto",
            bgcolor: felixTokens.paperInk,
            color: felixTokens.dark.bg,
            "&:hover": { bgcolor: felixTokens.light.surface },
          }}
        >
          {ctaLabel}
        </Button>
      </CardContent>
    </Card>
  );
}
